import useTurnover from '../../../hooks/useTurnover';
import { Table } from '../../Table';
import React from 'react';
import { TableTitle, TableStyle } from './style';
import { TableComponentProps } from '../types';

export function Turnover({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { onChange: onChange, tables } = useTurnover({
    data: funds[currentDataKey]?.fund_data?.TURNOVER,
    onChangeFund,
    schema: schema.TURNOVER,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.TURNOVER?.field_names || [],
    isMultiFunds,
    funds
  });

  return tables.map((table, index) => (
    <React.Fragment key={`${table.name}-${index}`}>
      <TableTitle id={`fca-reporttables-turnover-title-${index + 1}`}>{table.name}:</TableTitle>
      <TableStyle id={`fca-reporttables-turnover-group-${index + 1}`}>
        {(table.tables as any).map((item: any, j: number) => (
          <div
            className="table-item"
            id={`fca-reporttables-turnover-item-${index + 1}-${j + 1}`}
            key={`${index}-${j}-${table.name}`}
          >
            <Table
              id={`fca-reporttables-turnover-table-${index + 1}-${j + 1}`}
              handleChanges={onChange}
              columns={item.columns}
              rows={item.rows}
              stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
            />
          </div>
        ))}
      </TableStyle>
    </React.Fragment>
  ));
}
